<template>
  <div />
</template>

<script>

export default {
  name: 'nasal-swab-action',
  props: [
    'valueBool',
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
  ],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'PROCEDURE',
        id: 'NASAL_SWAB',
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
</style>
